import axios from "axios";
import { navigate } from "./navigation";
import { getApiBaseUrl, normalizeRequestConfig } from "../utils/apiConfig";
import { expireSession } from './session';

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => normalizeRequestConfig(config),
  Promise.reject
);

api.interceptors.response.use(
  res => res,
  error => {
    const status = error?.response?.status;

    if (status === 401 && !error?.config?.skipAuthRedirect) {
      expireSession();
      navigate("/signin");
    }

    return Promise.reject({
      message:
        (typeof error?.response?.data === 'string' ? error.response.data : null) ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Server unavailable",
      status: status || 0,
      raw: error,
    });
  }
);

export default api;
